import { useInfiniteQuery, useQuery } from 'react-query'
import { api } from '../../../api'
import type PaginationDomain from '../../../../types/domain/pagination-domain'
import { type RequestDomain } from '../../../../types/domain/request-domain'
import { type FiltersDomain } from '../../../../types/domain/filters-domain'
import { getQueryStrinfied } from '../../../../utils/query'
import { getValidFilters } from '../../../../utils/filters'

export const fetchRequests = async (filters: FiltersDomain): Promise<PaginationDomain<RequestDomain>> => {
  const query = getQueryStrinfied(getValidFilters(filters))
  const response = await api.get(`/requests?${query}&sort=id&order=ASC`)
  return response.data
}

export const fetchRequest = async (id: number): Promise<RequestDomain> => {
  const response = await api.get(`/requests/${id}`)
  return response.data
}

export const useRequestsQuery = (filters: FiltersDomain) => {
  return useQuery<PaginationDomain<RequestDomain>>(
    ['requests', filters],
    () => fetchRequests(filters),
    { staleTime: 1000 * 60 * 60 * 1, keepPreviousData: true } // 1 hour
  )
}

export const useInfiniteRequestsQuery = (filters: FiltersDomain) => {
  return useInfiniteQuery<PaginationDomain<RequestDomain>>(
    ['requests', filters],
    ({ pageParam = 1 }) => fetchRequests({ ...filters, page: pageParam }),
    {
      staleTime: 1000 * 60 * 60 * 1, // 1 hour
      getNextPageParam ({ meta }) {
        return meta.hasNextPage ? meta.page + 1 : undefined
      },
    }
  )
}

export const useRequestQuery = (id: number | undefined | null) => {
  return useQuery(['request', id], () => fetchRequest(id!), {
    staleTime: 1000 * 60 * 60 * 1,
    keepPreviousData: true,
    enabled: id !== undefined && id !== null
  })
}
